import { recoverPhase1Run } from "./recoverPhase1Run";
import { patchAssistant } from "./phase1StreamPatch";
import { patchPhase1Error } from "./phase1StreamError";
import { publishArtifactDocuments } from "./publishArtifactDocuments";

function activityForBackground(run) {
  if (run.activity.length) return run.activity;
  return [
    {
      id: `${run.runId}:background`,
      tool: null,
      label: "Continuing in background",
      status: "running",
      arguments: null,
    },
  ];
}

export function startPhase1BackgroundRecovery(ctx, run) {
  patchAssistant(ctx, {
    activity: activityForBackground(run),
    demoStreamActive: true,
    thoughtSummary: "Continuing in background",
  });
  void recoverPhase1Run({
    tid: ctx.tid,
    runId: run.runId,
    signal: ctx.signal,
    onComplete: (answer) => {
      patchAssistant(ctx, {
        text: answer.text,
        blocks: answer.blocks ?? [],
        activity: [],
        workStatus: answer.workStatus ?? null,
        citations: answer.citations ?? [],
        memoryIds: [],
        phase1RunId: answer.phase1RunId,
        phase1MessageId: answer.id,
        demoStreamActive: false,
        thoughtSummary: answer.workStatus?.tasks?.some(
          (task) => task.status === "waiting",
        )
          ? "Waiting for approval or input"
          : "Response ready",
        phase1Error: false,
        phase1Interrupted: false,
      });
      publishArtifactDocuments(ctx.tid, answer.blocks);
    },
    onFailure: (message) => patchPhase1Error(ctx, new Error(message), run),
  });
}
